import { useTranslation } from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
import { sectionClass } from "../../config/sectionClasses.js";
import { sectionHeaderClass } from "../../config/sectionClasses.js";
import { Reveal } from "../Reveal.jsx";
import { formatRelativeTime } from "../../content/news.js";
import { loadAiNews } from "../../content/news.js";
const REFRESH_INTERVAL_MS = 5 * 60 * 1000;
function AiNewsItem({ item: item, index: index }) {
  return (
    <li className={"AiNews_item__nws01"}>
      <div className={"AiNews_index__nws01"}>
        {String(index + 1).padStart(2, "0")}
      </div>
      <div>
        <h4 className={"AiNews_itemTitle__nws01"}>
          <a href={item.url} target={"_blank"} rel={"noopener noreferrer"}>
            {item.title}
          </a>
        </h4>
        <div className={"AiNews_meta__nws01"}>
          <span>{item.host}</span>
          <span>·</span>
          <span>{item.by}</span>
          <span>·</span>
          <span>{formatRelativeTime(item.time)}</span>
        </div>
      </div>
      <div className={"AiNews_score__nws01"}>
        {item.score ? `▲ ${item.score}` : "link"}
      </div>
    </li>
  );
}
function AiNews() {
  let { t: translate } = useTranslation(),
    [items, setItems] = React.useState([]),
    [status, setStatus] = React.useState("loading"),
    [updatedAt, setUpdatedAt] = React.useState(""),
    mounted = (0, React.useRef)(true),
    busy = (0, React.useRef)(false),
    run = (0, React.useCallback)(async () => {
      if (busy.current) return;
      busy.current = true;
      setStatus((current) => (current === "ready" ? "refreshing" : "loading"));
      let result = await loadAiNews();
      busy.current = false;
      if (!mounted.current) return;
      setItems(result.items);
      setStatus(result.offline ? "offline" : "ready");
      setUpdatedAt(
        result.offline
          ? ""
          : new Date().toLocaleTimeString("zh-CN", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            }),
      );
    }, []);
  (0, React.useEffect)(
    () => (
      (mounted.current = true),
      run(),
      () => {
        mounted.current = false;
      }
    ),
    [run],
  );
  (0, React.useEffect)(() => {
    let e = window.setInterval(run, REFRESH_INTERVAL_MS);
    return () => window.clearInterval(e);
  }, [run]);
  let statusText =
    status === "refreshing"
      ? translate("home.aiNews.refreshing")
      : status === "offline"
        ? translate("home.aiNews.offline")
        : updatedAt
          ? translate("home.aiNews.updatedAt", { time: updatedAt })
          : "";
  return (
    <section className={`${sectionClass} AiNews_section__nws01`}>
      <Reveal>
        <div className={`${sectionHeaderClass} AiNews_head__nws01`}>
          <div className={"AiNews_headText__nws01"}>
            <div className={"AiNews_label__nws01"}>
              {translate("home.aiNews.label")}
            </div>
            <h2>{translate("home.aiNews.title")}</h2>
            <p>{translate("home.aiNews.desc")}</p>
          </div>
          <button
            type={"button"}
            className={"AiNews_refresh__nws01"}
            onClick={run}
          >
            {translate("home.aiNews.refresh")}
          </button>
        </div>
      </Reveal>
      <Reveal>
        <div className={"AiNews_panel__nws01"}>
          <div className={"AiNews_toolbar__nws01"}>
            <div className={"AiNews_status__nws01"}>
              <span className={"AiNews_liveDot__nws01"} />
              <span>{translate("home.aiNews.liveLabel")}</span>
            </div>
            <div className={"AiNews_status__nws01"}>{statusText}</div>
          </div>
          {items.length ? (
            <ul className={"AiNews_list__nws01"}>
              {items.map((item, index) => (
                <AiNewsItem key={item.url} item={item} index={index} />
              ))}
            </ul>
          ) : (
            <div className={"AiNews_empty__nws01"}>
              {translate("home.aiNews.loading")}
            </div>
          )}
        </div>
      </Reveal>
    </section>
  );
}
export { AiNews, AiNewsItem };
